import { NextPage } from 'next'
import Head from 'next/head'
import NavbarLayout from 'components/NavbarLayout'
import WhiteBox from 'components/WhiteBox/WhiteBox'
import { useEventSeriesBySlugQuery } from 'graphql/generated'
import EventSeriesList from 'components/events/EventSeriesList'
import ScreenLayout from 'components/ScreenLayout'

interface IProps {
  seriesSlug: string
}

const EventSeriesPage: NextPage<IProps> = ({ seriesSlug }) => {
  const { data } = useEventSeriesBySlugQuery({
    variables: {
      slug: seriesSlug
    },
    skip: !seriesSlug
  })

  return (
    <NavbarLayout>
      <Head>
        <title>{`Upstream | ${data?.eventSeriesBySlug?.label} Series`}</title>
      </Head>

      <ScreenLayout layout="blank">
        <div className="max-w-4xl lg:min-w-lg mx-auto space-y-4 relative">
          <WhiteBox
            padded={false}
            title={`${data?.eventSeriesBySlug?.label} events`}
          >
            <EventSeriesList slug={seriesSlug} />
          </WhiteBox>
        </div>
      </ScreenLayout>
    </NavbarLayout>
  )
}

export default EventSeriesPage

export const getServerSideProps = async ctx => {
  return {
    props: {
      seriesSlug: ctx.query.seriesSlug as string
    }
  }
}
